import { Component, JSX } from 'react';
import { appContext } from '../../AppContext';
import { LogOutReason } from '../../Common/Authentication';
import { IRouterProps, withRouting } from "@iconics/components";
import "./Styles.scss";

class NotFound extends Component<IRouterProps>
{
    private get local() { return appContext().localStorageProvider; }
    private get auth() { return appContext().authentication; }

    public render(): JSX.Element
    {
        const token = appContext().authentication.getToken();
        if (token)
        {
            this.props.navigate(-1);
        }
        else
        {
            this.auth.logOut(LogOutReason.SessionExpired);
        }
        return <></>
    }
}

export default withRouting<{}>(NotFound);
